module.exports = "<h3 class=\"code-header mt-0 mb-15\">Enter your validation code</h3>\n<input class=\"form-control\"\n       type=\"text\"\n       placeholder=\"Enter the 6-digit code\"\n       maxlength=\"6\"\n       [ngModel]=\"verificationCode\"\n       (blur)=\"onCodeType($event)\">"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/2fa/modals/two-fa-setup-modal/enter-code/enter-code.component.html
// module id = ./web/modern/components/2fa/modals/two-fa-setup-modal/enter-code/enter-code.component.html
// module chunks = 0